import React from 'react';

import {Card, CardContent, Stack, Typography} from 'views/components';
import {Table, TableCell, TableRow, TableHead, TableContainer, TableBody} from 'views/components';
import {MarkdownViewer} from 'views/module';
import {Translate, translate} from 'views/module';

const ScopeOfCareCard = () => {
  return (
    <Card>
      <CardContent>
        <Stack spacing={3}>
          <Stack>
            <Typography component='div' variant='h6'>
              <Translate expression={'dashboard.sections.info.scopeOfCareTitle'}/>
            </Typography>
            <Typography component='div' variant='body2' color='text.secondary'>
              <MarkdownViewer value={translate('dashboard.sections.info.scopeOfCare')}/>
            </Typography>
          </Stack>
          <TableContainer>
            <Table
              sx={{
                'borderCollapse': 'separate',
                'borderSpacing': 0,
                'tableLayout': 'fixed',
                '& th': {
                  bgcolor: 'background.default',
                  border: '1px solid',
                  borderColor: 'color.divider',
                },
                '& td': {
                  border: '1px solid',
                  borderColor: 'color.divider',
                },
                '& thead tr:first-of-type th:first-of-type': {
                  borderTopLeftRadius: '20px',
                },
                '& thead tr:first-of-type th:last-of-type': {
                  borderTopRightRadius: '20px',
                },
                '& tbody tr:last-of-type td:first-of-type': {
                  borderBottomLeftRadius: '20px',
                },
                '& tbody tr:last-of-type td:last-of-type': {
                  borderBottomRightRadius: '20px',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography component='div' variant='subtitle'>
                      <Translate expression={'dashboard.sections.info.whatTheyCanDoTitle'}/>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography component='div' variant='subtitle'>
                      <Translate expression={'dashboard.sections.info.whatTheyCannotDoTitle'}/>
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow1CanDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow1CanDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow1CannotDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow1CannotDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow2CanDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow2CanDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow2CannotDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow2CannotDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow3CanDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow3CanDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow3CannotDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow3CannotDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow4CanDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow4CanDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow4CannotDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow4CannotDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow5CanDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow5CanDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow5CannotDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow5CannotDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow6CanDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow6CanDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow6CannotDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow6CannotDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow7CanDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow7CanDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow7CannotDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow7CannotDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow8CanDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow8CanDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography component='div' variant='body2' fontWeight={600}>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow8CannotDoTitle'}/>
                    </Typography>
                    <Typography component='div' variant='body2' color='text.secondary'>
                      <Translate expression={'dashboard.sections.info.scopeOfCareRow8CannotDoSubtitle'}/>
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ScopeOfCareCard;
